import { IWidget } from 'common';

export type CarouselType = NonNullable<IWidget['settings']['carousel_type']>;
export type ShopThisLookDisplay = IWidget['settings']['shop_this_look_display'];

const DEFAULT_CAROUSEL_TYPE: CarouselType = 'spotlight';

// Retro-compatibility : Determine default carousel type based on shop this look display setting

export const getCarouselTypeFromShopThisLook = (
  shopThisLookDisplay?: ShopThisLookDisplay,
): CarouselType => {
  if (shopThisLookDisplay === 'modal') {
    return 'uniform';
  }

  if (shopThisLookDisplay === 'product_list') {
    return 'spotlight';
  }

  return DEFAULT_CAROUSEL_TYPE;
};

export const resolveCarouselTypeSelection = (
  carouselType: IWidget['settings']['carousel_type'],
  shopThisLookDisplay?: ShopThisLookDisplay,
): CarouselType => {
  return carouselType || getCarouselTypeFromShopThisLook(shopThisLookDisplay);
};
